/**
 * 返回官网
 */
export function backOffical() {
  if (location.host.startsWith("dev")) {
    window.location.href = `https://devweb.12times.com`;
  } else if (location.host.startsWith("qas")) {
    window.location.href = `https://qasweb.12times.com`;
  } else {
    window.location.href = `https://web.12times.com`;
  }
}

/** 获取埋点环境 */
export const getBurialPointEnv = () => {
  const host = window.location.host;
  const prodHost = ["web.12times.com", "platform.12times.com"];
  if (prodHost.includes(host)) {
    return "prod";
  } else {
    return "daily";
  }
};
